import { useEffect, useState } from 'react'
import { useAuth } from '../../Context/Authcontext'
import { Link } from 'react-router-dom';

const Cartstrip = () => {

    const {userdata} = useAuth();
    const [iscart, setIscart] = useState(false);

    useEffect(() => {
        if(userdata && userdata?.cart?.length > 0){
            setIscart(true);
        }else{
            setIscart(false);
        }
    }, [userdata])

    return (
        <div>
            {
                iscart && (
                    <div className="cart-strip-wrapper">
                        <div className="cart-strip bg-brand-secondary p-2 ps-4 rounded-pill text-white d-flex align-items-center justify-content-between">
                            <p className="mb-0">
                                <i className="fi fi-ss-shopping-cart me-2" style={{position: 'relative', bottom: '-1px'}}></i>
                                {
                                    userdata?.cart?.length > 0 && (
                                        userdata?.cart?.reduce((total, item) => total + item.quantity, 0)
                                    )
                                } {userdata?.cart?.reduce((total, item) => total + item.quantity, 0) > 1 ? 'Items': 'Item'}
                            </p>
                            <Link to='/cart' className='btn btn-brand-primary rounded-pill px-3'>View cart</Link>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Cartstrip